<!--
=========================================================
* FYMFinancial
=========================================================
* Copyright 2022 FYM Financial
=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>

  <div
    v-show="this.$store.state.layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>

  <sidenav
    :custom_class="this.$store.state.mcolor"
    v-if="this.$store.state.showSidenav"
  />

  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >

  <!--
  <span id="env">
    <img v-if="this.$node_env === 'localhost'"src="/img/localhost_Watermark.png">
    <img v-else-if="this.$node_env === 'development'"src="/img/dev_Watermark.png">
  </span>
  -->

    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />
    <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : ''
      ]"
    />
  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/FooterLoggedin.vue";
import { mapMutations } from "vuex";

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"])
  },
  computed: {
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && !this.$store.state.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && this.$store.state.darkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4": !this.$store.state.isAbsolute
      };
    }
  },
  beforeMount() {
    this.$store.state.isTransparent = "";
  },
  mounted() {
    if(this.$node_env == 'production') {
      document.title = `FYM App`;
    }
    else {
      document.title = `FYM App - ${this.$node_env}`;
    }
    
  }
};
</script>
<style>
#env {
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  text-align: left;
  z-index: 1000;
}
</style>